import { Suspense, lazy } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as Sonner } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import ScrollToTop from '@/components/ScrollToTop';

const queryClient = new QueryClient();
const Index = lazy(() => import('./pages/main/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
const Conference = lazy(() => import('@/pages/Conference'));
const Security = lazy(() => import('@/pages/security/Security'));
const DigitalTransformation = lazy(
  () => import('@/pages/digital-transformation/DigitalTransformation'),
);
const Management = lazy(() => import('@/pages/management/Management'));
const SoftwareDevelopment = lazy(() => import('@/pages/software-development/SoftwareDevelopment'));

const RouteFallback = () => (
  <div className="bg-background text-muted-foreground flex min-h-screen items-center justify-center px-6 text-sm">
    Loading…
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <ThemeProvider>
        <LanguageProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/conference" element={<Conference />} />
                <Route path="/security" element={<Security />} />
                <Route path="/digital-transformation" element={<DigitalTransformation />} />
                <Route path="/management" element={<Management />} />
                <Route path="/software-development" element={<SoftwareDevelopment />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </LanguageProvider>
      </ThemeProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
